import React, { forwardRef, useEffect } from 'react';

import { ToastProps } from './Toast.types';
import { ToastItem } from './components/ToastItem/ToastItem';
import { useToastContainer } from './hooks/useToastContainer';
import { st, classes } from './Toast.st.css';
import { motion, AnimatePresence } from 'framer-motion';

const Toast = forwardRef<HTMLDivElement, ToastProps>(
  ({ offset = '26px', zIndex = 5500, ...propsWithNoDefaults }, ref) => {
    const props = {
      offset,
      zIndex,
      ...propsWithNoDefaults,
    };
    const { toasts, containerRef } = useToastContainer(props);

    useEffect(() => {
      if (ref) {
        (ref as React.MutableRefObject<HTMLDivElement>).current =
          containerRef.current!;
      }
      // TODO: fix ESLint error
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const motionProps = {
      initial: { y: 150, x: 0, opacity: 0 },
      animate: { y: 0, x: 0, opacity: 1 },
      exit: { opacity: 0 },
    };

    return (
      <div
        ref={containerRef}
        className={st(classes.toastContainer, props.className)}
        data-hook={props.dataHook}
        style={{ zIndex: props.zIndex, bottom: props.offset }}
      >
        {/* @ts-ignore - TODO - update framer-motion after upgrading react 18 */}
        <AnimatePresence>
          {toasts.map(({ content, props: toastProps }) => (
            <motion.div
              key={`toast-${toastProps.key}`}
              layout
              transition={{ default: { ease: 'linear' } }}
              {...motionProps}
            >
              <ToastItem {...toastProps} key={`toast-${toastProps.key}`}>
                {content}
              </ToastItem>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    );
  },
);

Toast.displayName = 'Toast';

export default Toast;
